// extracted by mini-css-extract-plugin
export var arrow = "VideoSection-module--arrow--76254";
export var back = "VideoSection-module--back--d0a7c";
export var clickable = "VideoSection-module--clickable--a8f6f";
export var details = "VideoSection-module--details--94550";
export var header = "VideoSection-module--header--6fa70";
export var hide = "VideoSection-module--hide--fb2f4";
export var onlyShare = "VideoSection-module--onlyShare--46aeb";
export var partTimeline = "VideoSection-module--partTimeline--a8bf8";
export var progress = "VideoSection-module--progress--1b133";
export var root = "VideoSection-module--root--84729";
export var selected = "VideoSection-module--selected--0d106";
export var share = "VideoSection-module--share--304ea";
export var spacer = "VideoSection-module--spacer--28c8a";
export var tab = "VideoSection-module--tab--133f5";
export var tabs = "VideoSection-module--tabs--54bbf";
export var tags = "VideoSection-module--tags--d124c";
export var timeline = "VideoSection-module--timeline--9d0ae";
export var timelineContainer = "VideoSection-module--timelineContainer--42e8e";
export var timelinesContent = "VideoSection-module--timelinesContent--bdf1b";
export var timelinesToggle = "VideoSection-module--timelinesToggle--439d1";
export var timestampsTimeline = "VideoSection-module--timestampsTimeline--abf07";
export var title = "VideoSection-module--title--68a08";
export var unCollapsed = "VideoSection-module--unCollapsed--09365";
export var video = "VideoSection-module--video--b68a8";
export var videoContainer = "VideoSection-module--videoContainer--c1214";
export var videoPlayer = "VideoSection-module--videoPlayer--1bd16";
export var videoWrapper = "VideoSection-module--videoWrapper--55453";
export var youtube = "VideoSection-module--youtube--ce308";